module.exports = __webpack_public_path__ + "static/media/keto360slim-5.196a3dd7.png";